import { categoria } from "./categoria";
import { nivel } from "./nivel";
import { tema } from "./tema";

export const classificacao = [...categoria, ...nivel, ...tema];



// WEBPACK FOOTER //
// ./src/routes/prova/classificacao/index.js